/* eslint-disable class-methods-use-this */
import Token from '../models/token';
import TokenDto from '../dtos/token-dto';

export default class TokenMapping {
  fromJson(data: Token): TokenDto {
    return {
      tokenType: data.token_type,
      expiresIn: data.expires_in,
      extExpiresIn: data.ext_expires_in,
      expiresOn: data.expires_on,
      notBefore: data.not_before,
      resource: data.resource,
      access_token: data.access_token,
    };
  }

  generateFromJson(data: Token): TokenDto {
    return this.fromJson(data);
  }
}
